(function () {
  'use strict';

  function initStickyOverride() {
    var sticky = document.getElementById('vp-sticky');
    if (!sticky) return;

    sticky.classList.remove('vp-visible');
    sticky.setAttribute('aria-hidden', 'true');

    var active = false;
    var THRESHOLD = 0.65;

    function update() {
      var scrolled = window.scrollY || window.pageYOffset;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = maxScroll > 0 ? scrolled / maxScroll : 0;
      var show = ratio >= THRESHOLD;

      if (show !== active) {
        active = show;
        if (show) {
          sticky.classList.add('vp-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('vp-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyOverride);
  } else {
    initStickyOverride();
  }
})();
